import { render, staticRenderFns } from "./ViewJobs.vue?vue&type=template&id=2554b11a&scoped=true&"
import script from "./ViewJobs.vue?vue&type=script&lang=js&"
export * from "./ViewJobs.vue?vue&type=script&lang=js&"
import style0 from "./ViewJobs.vue?vue&type=style&index=0&id=2554b11a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2554b11a",
  null
  
)

export default component.exports